<template>
  <v-form @submit.prevent.stop="saveCompany" class="color--fix">
    <v-card>
      <v-card-title>Company Information</v-card-title>
      <v-card-actions>
        <v-row>
          <v-col>
            <v-text-field
              label="Company name"
              placeholder="Company name"
              outlined rounded clearable
              v-model.trim="companyName"
              :disabled="loading"
            />

            <v-text-field
              label="Company domain"
              placeholder="e.g. https://www.example.com"
              outlined rounded clearable
              v-model.trim="companyDomain"
              :disabled="loading"
            />

            <v-select
              :items="productsList"
              v-model="product"
              label="Product name"
               rounded
              :disabled="true"
            ></v-select>

            <v-text-field
              label="Office 365 Tenant ID"
              placeholder="Office 365 Tenant ID"
              outlined rounded clearable autofocus
              v-model.trim="tenant_name"
              :disabled="loading"
            />

            <p class="margin-left-50">Need help finding your Microsoft 365 Tenant ID? <a href="https://docs.microsoft.com/en-us/onedrive/find-your-office-365-tenant-id?WT.mc" target="_blank">Click here</a></p>

          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <br/>
    <v-row>
      <v-col :cols="isMobile ? 12 : 2">
        <v-btn
          :block="isMobile"
          type="submit"
          color="primary"
          x-large
          rounded
          min-width="250"
          :disabled="buttonDisabled"
        >
          Save
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {isMobileMixin} from "@/mixins";

export default {
  name: "Company",
  mixins: [isMobileMixin],
  data() {
    return {
      companyName: '',
      companyDomain: '',
      productsList: [],
      product: null,
      tenant_name: '',
      fieldValidator: [
        (val) => (!val || "mandatory field")
      ]
    }
  },

  computed: {
    ...mapState(['loading', 'profile']),
    buttonDisabled() {
      return (
          this.companyName === (this.profile ? this.profile.company : '')
          && this.companyDomain === (this.profile ? this.profile.domain : '')
          && this.product === (this.profile ? this.profile.product : '')
          && this.tenant_name === (this.profile ? this.profile.tenant_name : '')
        ) || this.loading
    }
  },

  methods: {
    ...mapActions(['getProfile', 'updateProfile']),
    resetCompanyData() {
      if (!this.profile) return
      this.companyName = this.profile ? this.profile.company : ''
      this.companyDomain = this.profile ? this.profile.domain : ''
      this.productsList = this.profile ? [this.profile.product] : []
      this.product = this.profile ? this.profile.product : ''
      this.tenant_name = this.profile ? this.profile.tenant_name : ''
    },
    async saveCompany() {
      if (this.buttonDisabled) return
      await this.updateProfile({
        company: this.companyName,
        domain: this.companyDomain,
        tenant_name: this.tenant_name,
      })
    },
  },

  async mounted() {
    if (!this.profile) await this.getProfile()
    this.resetCompanyData()
  },
}
</script>

<style scoped>
.margin-left-50 {
  margin-left: 50px;
}
</style>
